import { withStyles, withTheme } from "@material-ui/core";
import React, {memo} from "react";
import { compose } from "recompose";
import styles from "./styles";
import EditIcon from "@material-ui/icons/Edit";
import { withFeatureFlags } from "../../../../../../../../userProfile/featureFlagsContext";
import { withAppConfig } from "@appConfigContext";
import { PICKUP_MANAGEMENT_MODES } from "../../../PickupManagement/constants";
import StyledToolTip from "../../../../../../../common/StyledToolTip";
import appConstants from "../../../../../../../../appConstants";
import { PICKUP_STATUS } from "../../../../constants";

class EditPickup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      enable: false,
      isBulkEdit: false,
    };
    this.selectedInvalidPickup = null;
  }

  componentDidMount() {
    this.props.eventHub.on(
      `${this.props.headerId}_updatePickupManagementIconStatus`,
      this.changeEditPickupStatus
    );
  }

  componentWillUnmount() {
    this.props.eventHub.off(
      `${this.props.headerId}_updatePickupManagementIconStatus`,
      this.changeEditPickupStatus
    );
  }

  isSameGroupSelection = (selectedPickups) => {
    if (selectedPickups.length <= 1) {
      return false;
    }
    const firstGroupId = selectedPickups[0]?.groupId;
    if (!firstGroupId) {
      return false;
    }
    return selectedPickups.every((pickup) => pickup.groupId === firstGroupId);
  };

  changeEditPickupStatus = ({ selectedPickups }) => {
    this.selectedInvalidPickup = selectedPickups.reduce((selectedInvalidPickup, pickup) => {
        if(selectedInvalidPickup) return selectedInvalidPickup;
        if(pickup.isCompleted) return "Completed";
        if(pickup.isVoided) return "Voided";
        if(pickup.isNoFreight && pickup.status === PICKUP_STATUS.unassigned) return "No freight + unassigned";
        return selectedInvalidPickup
      }, null)

    const isBulkEdit = this.props.configJSON?.enableBulkEditAndVoid && this.isSameGroupSelection(selectedPickups);
    const isSingleEdit = selectedPickups.length === 1;
    const isEnabled = (isSingleEdit || isBulkEdit) && !this.selectedInvalidPickup;
    this.setState({
      enable: isEnabled,
      isBulkEdit: isBulkEdit && isEnabled,
    });
  };

  getTooltipMessage = (enablePickupEdit) => {
    if (!enablePickupEdit) {
      return "Edit pickup (Disabled)";
    } 
    if(this.selectedInvalidPickup) {
        return `${this.selectedInvalidPickup} pickup cannot be edited`
    }
    if (this.state.isBulkEdit) {
      return "Click to edit group";
    }
    if (this.state.enable) {
      return "Click to edit pickup";
    }
    return this.props.configJSON?.enableBulkEditAndVoid
      ? "Select a group or single pickup to edit"
      : "Select a single pickup to edit";
  };

  onEditPickupEvent = () => {
    if (!this.state.enable) {
      return;
    }
    this.props.eventHub.emit("pickupManagement", {
      action: this.state.isBulkEdit
        ? PICKUP_MANAGEMENT_MODES.BULK_EDIT_PICKUP
        : PICKUP_MANAGEMENT_MODES.EDIT_PICKUP,
    });
  };

  render() {
    const { classes } = this.props;
    const { enable } = this.state;
    const enablePickupEdit = this.props.featureFlags.isFeatureEnabled(
      appConstants.features.EnablePickupEdit
    );
    return (
      <div
        className={`${classes.headerIconStyles} ${
          classes.iconLayout
        } glHeaderIcons ${
          enablePickupEdit && enable ? classes.enabledIcon : classes.disableIcon
        }`}
        onClick={enablePickupEdit && enable ? this.onEditPickupEvent : null}
      >
        <StyledToolTip title={this.getTooltipMessage(enablePickupEdit)}>
          <EditIcon />
        </StyledToolTip>
      </div>
    );
  }
}

export default compose(withStyles(styles), withFeatureFlags, withAppConfig, withTheme())(memo(EditPickup));